 <ngx-dynamic-hooks #hooksEl class="RenderMath" [class.kh-question-text--reading]="textToSpeechService.isPlaying$ | async" [parsers]="dynamicComponents" [content]="questionText" [context]="dynamicContext" [options]="dynamicOptions"></ngx-dynamic-hooks>

